<template>
    <div>
        <sonicu-header>Alarm Counts</sonicu-header>
        <div class="mt-3 overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
                <thead>
                    <tr>
                        <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ rowHeader }}</th>
                        <th v-for="column in columns" :key="column.key"
                            class="px-4 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">{{ column.label }}</th>
                    </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="(row, index) in sortedData" :key="index">
                        <td class="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-900">{{ row.name }}</td>
                        <td v-for="column in columns" :key="column.key"
                            class="px-4 py-2 whitespace-nowrap text-sm text-right text-gray-700">{{ row[column.key] || 0 }}</td>
                    </tr>
                    <tr v-if="data.length === 0">
                        <td :colspan="columns.length + 1" class="px-4 py-4 text-center text-sm text-gray-500">No alarms in this period.</td>
                    </tr>
                </tbody>
                <tfoot v-if="data.length > 0" class="bg-gray-50">
                    <tr>
                        <td class="px-4 py-2 whitespace-nowrap text-sm font-semibold text-gray-900">Total</td>
                        <td v-for="column in columns" :key="column.key"
                            class="px-4 py-2 whitespace-nowrap text-sm text-right font-semibold text-gray-900">{{ columnTotal(column.key) }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
import {iconNamesMixin} from "@/mixins/IconNamesMixin";

// Reusable across both the overall summary (rows = regions) and the per-region
// blocks (rows = locations/sites). The first column's heading is driven by the
// `rowHeader` prop; every row just needs a `name` plus the metric keys below.
export default {
    name: "RegionAlarmCountTable",
    mixins: [iconNamesMixin],
    props: {
        // Heading for the first (label) column, e.g. "Region" or "Location".
        rowHeader: {
            type: String,
            default: "Name",
        },
        // [{ name, threshold, offline, snoozed, active }]
        data: {
            type: Array,
            default: () => [],
        },
        // The metric columns. Overridable so the same table can render a
        // different set of counts later without touching the template.
        columns: {
            type: Array,
            default: () => [
                {key: "threshold", label: "Threshold"},
                {key: "offline", label: "Offline"},
                {key: "snoozed", label: "Snoozed"},
                {key: "active", label: "Active Alarms"},
            ],
        },
    },
    computed: {
        // Show the busiest locations/regions first — sorted by active alarm count, descending.
        // Copied so the `data` prop is never mutated; Array.sort is stable, so equal-count rows
        // keep their original (backend) order.
        sortedData() {
            return [...this.data].sort((a, b) => (b.active || 0) - (a.active || 0));
        },
    },
    methods: {
        columnTotal(key) {
            return this.data.reduce((sum, row) => sum + (row[key] || 0), 0);
        },
    },
};
</script>

<style scoped>
</style>
